var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2220_5720)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4406 11.4108C17.2753 12.6708 16.7703 13.862 15.9795 14.8567C15.1887 15.8515 14.142 16.6121 12.9518 17.0572C11.7615 17.5023 10.4726 17.615 9.22315 17.3832C7.97372 17.1514 6.81095 16.5839 5.85956 15.7415C4.90816 14.8991 4.20402 13.8136 3.82266 12.6014C3.4413 11.3892 3.3971 10.0961 3.69481 8.86073C3.99251 7.62534 4.62089 6.4943 5.51255 5.5889C6.40421 4.6835 7.52551 4.0379 8.7562 3.72134C12.1678 2.84634 15.6993 4.60246 17.0031 7.87496",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 3.5V7.875H13.125",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2220_5720"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame);
export default __webpack_public_path__ + "static/media/Frame.ca76a09ecc11e8c131eccf2fde5ba9ac.svg";
export { ForwardRef as ReactComponent };